<template>
  <div class="details" v-if="item">
    <div class="details__top-bg"/>
    <div class="details__main-green">
      <img :src="item.featured_image || '/images/default-photo.png'" class="details__img"/>
      <div class="details__wrap">
        <div class="status-group flex align-center mg-t-15">
          <img v-if="isPlace" class="details__img-btn" :class="{ 'gray-scale': hasCheckedIn }" :src="checkinImg" @click="checkin"/>
          <img class="details__img-btn" v-if="item.vr_link != null && item.vr_link[this.language]" @click="openVr" src="/images/vr.png"/>
          <span class="details__status-text" v-if="isCheckIn == 1">{{$t('places.is_checkined')}}</span>
          <span class="details__status-text" v-if="isSubmit == 1">{{$t('places.is_submitted')}}</span>
        </div>
        <div class="mg-t-20">
          <div class="details__title-row">
            <h2>{{title}}</h2>
            <img v-if="language === 'zh-Hant'" @click.stop="speakContent('zh-HK')" class="details__img-btn speak-icon" src="/images/icon_Voice_Chi.svg" />
            <img v-if="language === 'en'" @click.stop="speakContent('en-US')" class="details__img-btn speak-icon" src="/images/icon_Voice_Eng.svg" />
          </div>
          <div v-if="isSpeechActive" class="details__speech-controls">
            <button type="button" @click="toggleSpeechPause">
              {{isSpeechPaused ? $t('details.resume') : $t('details.pause')}}
            </button>
            <button type="button" @click="stopSpeech">
              {{$t('details.stop')}}
            </button>
            <label>
              {{$t('details.speed')}}
              <select v-model.number="speechRate" @change="changeSpeechRate">
                <option :value="0.75">0.75x</option>
                <option :value="0.85">0.85x</option>
                <option :value="1">1x</option>
                <option :value="1.25">1.25x</option>
              </select>
            </label>
          </div>
          <h3 v-if="isPlace">{{address}}</h3>
          <h3 v-if="isPlace">{{item.latitude}}, {{item.longitude}}</h3>
        </div>
      </div>
      <div class="details__mid-bg"/>
      <div class="details__wrap mg-t-15" v-html="description"/>
      <div class="gallery mg-t-10" v-if="item.media?.length">
        <div class="gallery__content" :style="{ left: galleryLeftPosition }">
          <div class="gallery__img" v-for="(media, index) in item.media" :key="media.id" @click="openImageModal(index)">
            <img :src="media.original_url"/>
          </div>
        </div>
        <img src="/images/nav-left.png" class="gallery__left" v-if="hasMoreLeft" @click="galleryNav('back')"/>
        <img src="/images/nav-right.png" class="gallery__right" v-if="hasMoreRight" @click="galleryNav('next')"/>
      </div>
      <div class="details__wrap mg-t-10">
        <div class="details__activities flex align-center justify-center">
          <div v-if="item.questionnaire" @click="showQuizModal = true">
            <img src="/images/quiz-en.png" class="details__quiz"/>
          </div>
          <button
            v-if="vocabularyTerms.length"
            type="button"
            class="details__vocabulary"
            @click="showVocabularyModal = true"
          >
            {{$t('vocabulary.title')}}
          </button>
        </div>
        <div class="flex align-center flex-wrap mg-t-20 pd-b-15">
          <router-link :to="`/places?tagId=${tag.id}&tagName=${tagName(tag)}&searchTerm=${tagName(tag)}`" class="details__chip" v-for="tag in item.tags" :key="tag.id">{{tagName(tag)}}</router-link>
        </div>
      </div>
    </div>
    <div class="details__bottom-bg"/>
    <div class="details__wrap-sm flex direction-column" v-if="isPlace">
      <router-link v-for="history in item.histories" :key="history.id" :to="`/histories/${history.id}`" >{{historyTitle(history)}}</router-link>
    </div>
    <!--  TODO: find a better way handle video here   -->
    <div class="details__wrap-sm video-player" v-if="item.video_link">
      <iframe class="video-player__video" :src="`https://www.youtube.com/embed/${youtubeId(item.video_link)}`" allow="fullscreen;"/>
    </div>
    <div class="details__city-bg"/>

    <vue-final-modal
      v-model="showImgModal"
      classes="modal-container"
      content-class="modal-content w-600"
    >
      <div class="modal-title">
        <div class="modal-title-left">
          <img src="/images/close-icon.png" @click="toggleImgModal"/>
        </div>
        <h3>{{title}}</h3>
        <div class="modal-title-right"/>
      </div>
      <div class="modal-body" v-if="this.item.media.length">
        <img :src="this.item.media[this.openedPicture].original_url" class="gallery__expanded-img" />
      </div>
    </vue-final-modal>

    <vue-final-modal
      v-model="showRewardModal"
      classes="modal-container"
      content-class="modal-content modal-contained w-300"
    >
      <div v-if="!showRewardContent" class="loading-animation">
        <img class="m-film" :src="gifSrc" />
      </div>

      <div v-else class="box-congratulate">
        <img class="congratulate-image" src="/images/M-Congratulate-character.gif"/>
        <div class="modal-title no-bg">
          <div class="modal-title-left">
            <img src="/images/close-icon.png" @click="showRewardModal = false" />
          </div>
          <h3></h3>
          <div class="modal-title-right"/>
        </div>
        <div class="modal-body pd-b-20 pd-l-20 pd-r-20 points-modal">
          <h3>{{$t('details.got')}}</h3>
          <p>{{awardedPoints}} {{$t('details.pieces')}}</p>
          <img src="/images/film.png"/>
          <button class="btn btn--orange blocked" @click="showRewardModal = false">
            {{$t('details.continue')}}
          </button>
        </div>
      </div>
    </vue-final-modal>

    <quiz-modal :show="showQuizModal" :quiz="item.questionnaire" @toggle="toggleQuizModal" @completed="quizCompleted"/>
    <vocabulary-modal :show="showVocabularyModal" :terms="vocabularyTerms" @toggle="toggleVocabularyModal"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import QuizModal from '@/components/quiz/quiz'
import VocabularyModal from '@/components/vocabulary/vocabulary'
import { createSpeechPlayer, defaultSpeechRate, speechContentLanguage } from '@/utils/speech'

let vocabularyDataPromise

function loadVocabularyData () {
  if (!vocabularyDataPromise) {
    vocabularyDataPromise = window.fetch(`${process.env.BASE_URL}data/vocabulary.json`)
      .then(response => {
        if (!response.ok) throw new Error('Unable to load vocabulary data')
        return response.json()
      })
  }
  return vocabularyDataPromise
}

function normalizePlaceName (value) {
  return (value || '')
    .replace(/【[^】]*】/g, '')
    .normalize('NFKC')
    .toLowerCase()
    .replace(/[^a-z0-9\u3400-\u9fff]+/g, '')
}

export default {
  name: 'DetailsPage',
  components: { QuizModal, VocabularyModal },
  props: [
    'item',
    'checkinPoints',
    'type',
    'isCheckIn',
    'isSubmit'
  ],
  data () {
    return {
      videoPaused: true,
      showImgModal: false,
      showQuizModal: false,
      showVocabularyModal: false,
      showRewardModal: false,
      showRewardContent: false,
      gifSrc: '',
      galleryIndex: 0,
      awardedPoints: 0,
      openedPicture: 0,
      vocabularyTerms: [],
      isSpeechActive: false,
      isSpeechPaused: false,
      speechRate: 1,
      speechLanguage: null,
      speechPlayer: createSpeechPlayer()
    }
  },
  computed: {
    ...mapGetters({
      language: 'auth/language'
    }),
    checkinImg () {
      return `/images/checkin-${this.language}.png`
    },
    title () {
      if (this.isPlace) {
        return this.item.name[this.language] || this.item.name[Object.keys(this.item.name)[0]]
      } else {
        return this.item.title[this.language] || this.item.title[Object.keys(this.item.title)[0]]
      }
    },
    description () {
      return this.item.description[this.language] || this.item.description[Object.keys(this.item.description)[0]]
    },
    address () {
      return this.item.address[this.language] || this.item.address[Object.keys(this.item.address)[0]]
    },
    vr_link () {
      return this.item.vr_link[this.language] || this.item.vr_link[Object.keys(this.item.vr_link)[0]]
    },
    hasCheckedIn () {
      console.log('detailvue isWithDistance' + !!this.item.isWithinDistance)
      console.log('detailvue localStorage loginToken' + window.localStorage.getItem('loginToken'))
      console.log('detailvue sessionStorage loginToken' + window.sessionStorage.getItem('loginToken'))
      return !!this.item.checkins.length || !this.item.isWithinDistance
      // console.log('detailsvue' + this.item.checkins.length)
      // return !!this.item.checkins.length
    },
    hasMoreLeft () {
      return this.galleryIndex > 0
    },
    hasMoreRight () {
      return this.galleryIndex < this.item.media.length
    },
    galleryLeftPosition () {
      return (-this.galleryIndex * 110) + 'px'
    },
    isPlace () {
      return this.type === 'place'
    },
    vr_link_lang () {
      return this.item.vr_link[this.language] || this.item.vr_link[Object.keys(this.item.vr_link)[0]]
    }
  },
  mounted () {
    this.loadVocabulary()
    this.setDefaultSpeechRate()
  },
  beforeUnmount () {
    this.stopSpeech()
  },
  methods: {
    toggleQuizModal (val) {
      console.log(JSON.stringify(val))
      this.showQuizModal = val
    },
    toggleVocabularyModal (value) {
      this.showVocabularyModal = value
    },
    async loadVocabulary () {
      this.vocabularyTerms = []
      this.showVocabularyModal = false
      if (!this.isPlace || !this.item?.id) return

      try {
        const data = await loadVocabularyData()
        const placeNames = Object.values(this.item.name || {}).map(normalizePlaceName)
        const vocabulary = data.places.find(place => {
          if (Number(place.placeId) === Number(this.item.id)) return true
          const vocabularyNames = [
            ...Object.values(place.placeName || {}),
            place.sourceHeading
          ]
            .map(normalizePlaceName)
          return vocabularyNames.some(vocabularyName => {
            return placeNames.some(placeName => {
              if (!vocabularyName || !placeName) return false
              if (vocabularyName === placeName) return true
              if (Math.min(vocabularyName.length, placeName.length) < 3) return false
              return vocabularyName.includes(placeName) || placeName.includes(vocabularyName)
            })
          })
        })
        this.vocabularyTerms = vocabulary?.terms || []
      } catch (error) {
        this.vocabularyTerms = []
      }
    },
    quizCompleted (points) {
      this.awardedPoints = points
      this.showQuizModal = false
      this.showRewardModal = true
      this.$emit('quizCompleted')
    },
    checkin () {
      if (!this.hasCheckedIn) {
        this.$emit('checkin')
      }
    },
    openVr () {
      if (this.isPlace) {
        window.open(this.vr_link_lang, '_blank').focus()
      } else {
        window.open(this.vr_link_lang, '_blank').focus()
      }
    },
    toggleVideo () {
      if (this.$refs.video.paused) {
        this.$refs.video.play()
        this.videoPaused = false
      } else {
        this.$refs.video.pause()
        this.videoPaused = true
      }
    },
    tagName (tag) {
      return tag.name[this.language] || tag.name[Object.keys(tag.name)[0]]
    },
    historyTitle (history) {
      return history.title[this.language] || history.title[Object.keys(history.title)[0]]
    },
    openImageModal (index) {
      this.openedPicture = index
      this.toggleImgModal()
    },
    galleryNav (type) {
      if (type === 'back') {
        this.galleryIndex = this.galleryIndex - 1
      } else {
        this.galleryIndex = this.galleryIndex + 1
      }
    },
    toggleImgModal () {
      this.showImgModal = !this.showImgModal
    },
    youtubeId (url) {
      /* eslint-disable */
      if(url === null) {
        return null
      }
      var match = url.match(/^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/)
      if (match && match[2].length === 11) {
        return match[2]
      } else {
        return null
      }
      /* eslint-enable */
    },
    speakContent (lang) {
      this.stopSpeech()
      const langKey = speechContentLanguage(lang)
      const requestedText = value => typeof value?.[langKey] === 'string' ? value[langKey].trim() : ''
      const title = requestedText(this.isPlace ? this.item.name : this.item.title)
      const address = this.isPlace ? requestedText(this.item.address) : ''
      const description = requestedText(this.item.description)
        .replace(/<[^>]*>/g, ' ')
        .replace(/&nbsp;/g, ' ')
        .replace(/&amp;/g, '&')
        .trim()
      const isChinese = langKey === 'zh-Hant'
      const parts = []
      if (title) parts.push(isChinese ? `標題：${title}。` : `Title: ${title}.`)
      if (address) parts.push(isChinese ? `地址：${address}。` : `Address: ${address}.`)
      if (description) parts.push(isChinese ? `內容：${description}` : `Content: ${description}`)

      this.speechLanguage = lang
      this.isSpeechActive = true
      this.isSpeechPaused = false
      const errorKey = this.speechPlayer.speak(parts.join(' '), lang, {
        rate: this.speechRate,
        onStart: () => {
          this.isSpeechActive = true
          this.isSpeechPaused = false
        },
        onFinish: () => this.resetSpeechState(),
        onError: () => window.alert(this.$t('vocabulary.speech_failed'))
      })
      if (errorKey) {
        this.resetSpeechState()
        window.alert(this.$t(errorKey))
      }
    },
    setDefaultSpeechRate () {
      this.speechRate = defaultSpeechRate(this.language === 'en' ? 'en-US' : 'zh-HK')
    },
    toggleSpeechPause () {
      if (!this.isSpeechActive) return

      if (this.isSpeechPaused) {
        if (this.speechPlayer.resume()) this.isSpeechPaused = false
      } else {
        if (this.speechPlayer.pause()) this.isSpeechPaused = true
      }
    },
    stopSpeech () {
      this.speechPlayer.stop()
      this.resetSpeechState()
    },
    resetSpeechState () {
      this.isSpeechActive = false
      this.isSpeechPaused = false
      this.speechLanguage = null
    },
    changeSpeechRate () {
      if (this.isSpeechActive && this.speechLanguage) {
        this.speakContent(this.speechLanguage)
      }
    }
  },
  watch: {
    showVocabularyModal (value) {
      if (value) this.stopSpeech()
    },
    checkinPoints () {
      this.awardedPoints = this.checkinPoints
      this.showRewardModal = true
    },
    showRewardModal (val) {
      if (val) {
        this.showRewardContent = false
        this.gifSrc = `/images/M-film_taken.gif?t=${Date.now()}`
        setTimeout(() => {
          this.showRewardContent = true
        }, 3500)
      }
    },
    'item.id' () {
      this.stopSpeech()
      this.loadVocabulary()
    },
    language () {
      this.stopSpeech()
      this.setDefaultSpeechRate()
    }
  }
}
</script>

<style scoped lang="scss">
  @import "style";
</style>
